import { useLocation, Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function RequireAuth({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-gray-600">
        Checking session...
      </div>
    );
  }

  if (!isAuthenticated) {
    const returnUrl = `${location.pathname}${location.search}`;
    return (
      <Navigate to={`/account/login?redirect=${encodeURIComponent(returnUrl)}`} replace />
    );
  }

  // Signed in but no business chosen yet: send to the profile selection first
  if (!localStorage.getItem("profileId") && location.pathname !== "/account/select-profile") {
    const returnUrl = `${location.pathname}${location.search}`;
    return (
      <Navigate to={`/account/select-profile?returnUrl=${encodeURIComponent(returnUrl)}`} replace />
    );
  }

  return <>{children}</>;
}
